/**
 * Routemize-owned external destinations surfaced in the app UI.
 */

/** Facebook Messenger invite for the Routemize Users community group chat. */
export const COMMUNITY_GROUP_URL =
  'https://m.me/j/AbaTSML-xJZ7pEDI/?send_source=gc:copy_invite_link_c';

export const openCommunityGroup = (): void => {
  window.open(COMMUNITY_GROUP_URL, '_blank', 'noopener,noreferrer');
};

/** Calendly booking page for the free 1:1 onboarding call with the Routemize team. */
export const SETUP_SESSION_URL =
  'https://calendly.com/d/d2ff-67z-whb/routemize-setup-session';

export const openSetupSession = (): void => {
  window.open(SETUP_SESSION_URL, '_blank', 'noopener,noreferrer');
};

/** Routemize iOS app listing on the Apple App Store. */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/routemize/id6743096179';

export const openAppStore = (): void => {
  window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
};

/** Routemize Android app listing on Google Play. */
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.routemize.mobile';

export const openPlayStore = (): void => {
  window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
};
